import { AsyncPipe, NgIf } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { TranslateModule } from '@ngx-translate/core';
import { GoogleReview } from '@sc/data-access-models';
import { LocaleDatePipe } from '@sc/data-access-translation';
import { RatingComponent } from '../rating';

@Component({
  selector: 'sc-fitter-comment',
  styleUrls: ['./fitter-comment.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    NgIf,
    RatingComponent,
    MatCardModule,
    TranslateModule,
    LocaleDatePipe,
    AsyncPipe,
  ],
  template: `
    <mat-card appearance="outlined" [class]="getCardClass()">
      <div class="author-name">
        <span class="name">{{ review.author_name?.trim() }}</span>
        <span *ngIf="!compact" class="date">{{
          'Fitter.customerReviewDate'
            | translate
              : {
                  date:
                    reviewTimeToDate(review.time)
                    | localeDate: 'longDate'
                    | async
                }
        }}</span>
      </div>
      <sc-rating [rating]="review?.rating"></sc-rating>
      <div class="author-text">
        {{ slicedAuthorText() }}
      </div>
    </mat-card>
  `,
})
export class FitterCommentComponent {
  @Input() review: GoogleReview;
  @Input() compact: boolean;
  @Input() sliceText: boolean;

  slicedAuthorText() {
    const sliceLimit = this.compact ? 70 : 140;

    return this.review.text.length > sliceLimit && this.sliceText
      ? this.review.text.slice(0, sliceLimit) + '...'
      : this.review.text;
  }

  reviewTimeToDate(reviewTimeInSeconds: number): Date {
    return new Date(reviewTimeInSeconds * 1000);
  }

  getCardClass() {
    return `fitter-comment-card ${this.compact ? 'compact-comment' : ''}`;
  }
}
